import React from 'react'
import { arrayOf, shape, string } from 'prop-types'
import changeFileExtension from '@/lib/filename-extension-modifier'
import styles from './ArticleImages.module.scss'
import ResponsiveImage from '../../ResponsiveImage'
import Grid from '../../Grid'

const InterviewImages = ({ images }) => {
  if (!images) return null
  return (
    <div className={styles.InterviewImages}>
      <Grid gutter="larger" flex>
        {Object.values(images.hero_portrait_144).map((img, i) => (
          <Grid.Item
            width={{ t: 1 / 4 }}
            trailingGap="mobile"
            key={`InterviewImage-${i}`}
          >
            <ResponsiveImage
              srcSet={[
                { src: changeFileExtension(img.url, 'webp'), width: 144 }
              ]}
              sizes={['144px']}
              loading="eager"
              width={144}
              src={img.url}
            />
          </Grid.Item>
        ))}
      </Grid>
    </div>
  )
}

InterviewImages.propTypes = {
  images: shape({
    src: string,
    alt: string,
    srcSet: arrayOf(
      shape({
        src: string,
        density: string
      })
    ),
    sizes: arrayOf(string)
  })
}

export default InterviewImages
